import { useEffect, useState } from 'react';

/**
 * Persist column visibility to localStorage.
 * @param {string} key - storage key (must be unique per table)
 * @param {string[]} defaults - default visible column ids
 * @param {{id:string,label:string,fixed?:boolean}[]} all - all available columns
 * @returns {[Set<string>, (id:string)=>void, ()=>void]}
 */
export function useColumnPrefs(key, defaults, all) {
  const [visible, setVisible] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) return new Set(arr);
      }
    } catch (_) { /* ignore */ }
    return new Set(defaults);
  });

  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify([...visible])); } catch (_) { /* ignore */ }
  }, [key, visible]);

  const toggle = (id) => {
    const col = all.find((c) => c.id === id);
    if (col?.fixed) return; // cannot toggle off
    setVisible((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };
  const reset = () => setVisible(new Set(defaults));
  return [visible, toggle, reset];
}
